import { StartupDataView } from '../modules/startupData/StartupDataView';
import { StartupSubPageShell } from './StartupSubPageShell';

/**
 * The startup's Data page (User Story 598): all of its shared data, the accounts people created
 * on its prototypes and their roles, and the data settings. The same view as the Data view in the
 * prototype workbench, in "All startup data" mode.
 */
export default function StartupDataPage(): JSX.Element {
  return (
    <StartupSubPageShell activeSection="data">
      {({ startupId }) => (
        <StartupDataView projectId={startupId} mode="startup" className="min-h-[70vh]" />
      )}
    </StartupSubPageShell>
  );
}
